import { useMutation } from "@tanstack/react-query";
import React from "react";
import { useModal } from "../../../../hooks";
import { uploadRmaDetailExcelApi } from "../../../../api/support/RMA";
import { AxiosError } from "axios";
import { UseFormSetValue } from "react-hook-form";
import { RmaDetailType } from "../../../../types/support";

type Props = {
  setValue: UseFormSetValue<RmaDetailType>;
};

const useUploadRmaExcel = ({ setValue }: Props) => {
  const { handleModal } = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: FormData) => uploadRmaDetailExcelApi(data),
    onSuccess: (res) => {
      handleModal({
        isOpen: true,
        contents: "엑셀 파일을 가져왔습니다.",
        type: "alert",
      });

      const result = res?.result;
      console.log(res);

      setValue("agreementNumber", result?.agreementNumber);
      setValue("contactInformation", result?.contactInformation);
      setValue("distributorName", result?.distributorName);
      setValue("msSoldToNumber", result?.msSoldToNumber);
      setValue("rmaDetailList", result?.uploadRmaDetailExcelResList);
      setValue("quantity", result?.uploadRmaDetailExcelResList?.length);
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
      if (error?.response?.data?.msg) {
        handleModal({
          isOpen: true,
          contents: error?.response?.data?.msg,
          type: "alert",
        });
      }
    },
  });
  return { mutate };
};

export default useUploadRmaExcel;
